export const markAsSpamCopy = {
  header: '',
  description: '',
  confirmBtnText: '',
  successToast: '',
};
